import Vue from "vue";
import Vuex from "vuex";
import NotificationService from "@/services/notification.service";
import authApiService from "../utils/AuthApiService";
import documentApiService from "../utils/DocumentApiService";
import mailApiService from "../utils/MailApiService";
import apiService from "../utils/apiService";

// Modules
import app from "./app";
import auth from "./auth";
import apikeys from "./apikeys";
import coupons from "./coupons";
import news from "./news";
import customerActivities from "./customerActivities";
import customerNotes from "./customerNotes";
import caseLists from "./caseLists";
import customers from "./customers";
import invoices from "./invoices";
import plans from "./plans";
import permissions from "./permissions";
import packages from "./packages";
import flags from "./flags";
import countryPackages from "./countryPackages";
import referralLinks from "./referralLinks";
import roles from "./roles";
import users from "./users";
import units from "./units";
import mailTemplates from "./mailtemplates";
import countryCredits from "./countryCredits";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import documentService from "./documentService";
import invoiceReminderLevel from "./invoiceReminderLevel";
import globalConfiguration from "./globalconfiguration";
import materialsConfiguration from "./materialsConfiguration";
import tickets from "./tickets";
import ticketComments from "./ticketComments";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    pusher: null,
    isLoading: false,
    showLoader: false,
    errors: {},
    flashMessage: {
      show: false,
      message: "",
      type: "",
      link: "",
    },
    isPublic: false,
    language: "en",
  },
  getters: {
    pusher: (state) => state.pusher,
    errors: (state) => state.errors,
    flashMessage: (state) => state.flashMessage,
    isLoading: (state) => state.isLoading,
    showLoader: (state) => state.showLoader,
    isPublic: (state) => state.isPublic,
    language: (state) => state.language,
  },
  mutations: {
    pusher: (state, payload) => (state.pusher = payload),
    language: (state, payload) => (state.language = payload),
    errors: (state, payload) => {
      const tempErrors = {};
      for (let key in typeof payload === "object" ? payload : {}) {
        tempErrors[key] =
          payload[key] instanceof Array ? payload[key]?.[0] : payload[key];
      }
      state.errors = tempErrors;
    },
    flashMessage: (state, payload) => {
      setTimeout(() => {
        state.flashMessage = payload;
        if (payload.show === true) {
          if ((payload.type = "error"))
            NotificationService.showError(payload.message);
          else {
            NotificationService.showInfo(payload.message);
          }
        }
      }, 1);
    },
    isLoading: (state, payload) => (state.isLoading = payload),
    showLoader: (state, payload) => (state.showLoader = payload),

    isPublic: (state, payload) => (state.isPublic = payload),
  },
  actions: {
    showResponse({ commit }, { type, message, errors, error, link }) {
      if (type === "success") {
        commit("flashMessage", {
          show: true,
          message: message,
          type: "success",
          link: link,
        });
      } else if (type === "error") {
        commit("errors", errors, {
          root: true,
        });
        commit("flashMessage", {
          show: true,
          message: message,
          type: "error",
          link: link,
        });
        throw new Error(message, { cause: error });
      }
    },
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    apikeys,
    users,
    permissions,
    roles,
    caseLists,
    customers,
    invoices,
    plans,
    coupons,
    news,
    units,
    documentService,
    invoiceReminderLevel,
    mailTemplates,
    countryCredits,
    globalConfiguration,
    materialsConfiguration,
    packages,
    flags,
    countryPackages,
    referralLinks,
    tickets,
    ticketComments,
    customerActivities,
    customerNotes,
  },
  strict: process.env.DEV,
});

store.$authApiService = authApiService;
store.$documentApiService = documentApiService;
store.$mailApiService = mailApiService;
store.$apiService = apiService;

export default store;
